"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const epic_react_common_1 = require("epic-react-common");
const seamless_immutable_1 = __importDefault(require("seamless-immutable"));
const decorators_1 = require("alt-utils/lib/decorators");
const InviteActions_1 = __importDefault(require("../actions/InviteActions"));
const InviteSource_1 = __importDefault(require("../sources/InviteSource"));
const epic_alt_utils_1 = require("epic-alt-utils");
const Message_1 = require("../components/message/Message");
let InviteStore = class InviteStore {
    constructor() {
        this.on('error', error => {
            console.error(error);
        });
        this.state = seamless_immutable_1.default({
            currentStage: 'INVITE',
            nextStage: '',
            currentInvites: 0,
            loading: false,
            errorMsg: '',
            prevPath: ''
        });
        this.bindActions(InviteActions_1.default);
    }
    onGetCurrentInvites(isLoggedIn) {
        if (isLoggedIn) {
            this.setState(this.state.merge({ loading: true }));
            this.getInstance().getCurrentInvites();
        }
        else {
            this.setState(this.state.merge({ currentStage: 'LOGIN' }));
        }
    }
    onGetCurrentInvitesSuccess(response) {
        if (response.status === 200 && !response.data.errorCode) {
            this.setState(this.state.merge({
                currentInvites: response.data.invites,
                loading: false
            }));
        }
        else {
            let newState = this.state.merge({
                loading: false
            });
            // Redirect to LOGIN Page if errorCode respondes account not logged in
            // this is unlikely as we check login status before geting invites
            if (response.data.errorCode === 'epic.code.invite.error.account_not_logged_in') {
                newState = newState.merge({ currentStage: 'LOGIN' });
            }
            this.setState(newState);
        }
    }
    onGetCurrentInvitesFailure(error) {
        this.setState(this.state.merge({
            errorMsg: Message_1.localizedMessage('epic.code.invite.failure.msg'),
            loading: false
        }));
    }
    onSendInvite(inviteOptions) {
        const { isLoggedIn, email } = inviteOptions;
        if (isLoggedIn) {
            this.setState(this.state.set('loading', true));
            this.getInstance().sendInvite(email);
        }
        else {
            this.setState(this.state.merge({
                currentStage: 'LOGIN',
                loading: false
            }));
        }
    }
    onSendInviteSuccess(response) {
        const errorMsg = Message_1.localizedMessage('epic.code.invite.failure.msg');
        if (response.status === 200 && response.data.success === true) {
            this.setState(this.state.merge({
                currentInvites: response.data.invites,
                currentStage: 'SUCCESS',
                loading: false
            }));
        }
        else if (!response.data.success) {
            // errorCode handling
            this.handleError(response.data.errorCode);
            this.setState(this.state.merge({
                loading: false
            }));
        }
        else {
            this.setState(this.state.merge({
                errorMsg,
                loading: false
            }));
        }
    }
    onSendInviteFailure(error) {
        const errorMsg = error.response && error.response.data && error.response.data.errorMessage
            ? error.response.data.errorMessage
            : Message_1.localizedMessage('epic.code.invite.failure.msg');
        this.setState(this.state.merge({
            errorMsg,
            loading: false
        }));
    }
    reset() {
        this.setState(this.state.merge({
            currentStage: 'INVITE',
            errorMsg: '',
            loading: false
        }));
    }
    getPrevPath(path) {
        if (!path)
            return; // stop if no argument
        if (path !== '/fortnite/invite') {
            this.setState(this.state.merge({
                prevPath: path
            }));
        }
    }
    handleError(error) {
        console.log('HANDLE ERROR');
        if (error.recipientEmail) {
            console.log('HANDLE ERROR: email error');
            switch (error.recipientEmail.errorCode) {
                case 'errors.com.epicgames.web.entitlement.already_entitled':
                    this.setState(this.state.merge({
                        errorMsg: Message_1.localizedMessage('epic.code.invite.error.is_entitled')
                    }));
                    break;
                case 'errors.com.epicgames.web.entitlement.no_invites_left':
                    this.setState(this.state.merge({
                        errorMsg: Message_1.localizedMessage('epic.code.invite.error.no_invites')
                    }));
                    break;
                case 'errors.com.epicgames.web.email.invalid_email':
                    this.setState(this.state.merge({
                        errorMsg: Message_1.localizedMessage('epic.code.invite.error.invalid_email')
                    }));
                    break;
                case 'errors.com.epicgames.web.email.sending_failed':
                    this.setState(this.state.merge({
                        errorMsg: Message_1.localizedMessage('epic.code.invite.error.sending_failed')
                    }));
                    break;
                default:
                    this.setState(this.state.merge({
                        errorMsg: Message_1.localizedMessage('epic.code.invite.error.sending_failed')
                    }));
            }
        }
        else if (error === 'errors.com.epicgames.common.account_not_logged_in') {
            this.setState(this.state.merge({
                currentStage: 'LOGIN'
            }));
        }
        else {
            console.log("An error exception that hasn't been handled properly");
        }
    }
};
InviteStore = __decorate([
    decorators_1.datasource(InviteSource_1.default),
    epic_alt_utils_1.seamlessImmutable,
    __metadata("design:paramtypes", [])
], InviteStore);
exports.default = epic_react_common_1.alt.createStore(InviteStore, 'InviteStore');
//# sourceMappingURL=InviteStore.js.map